import { Observable } from 'rxjs';

import type { SelectOption } from '@core/user-interface-legacy';

export type UserSelectOption = SelectOption & { photoThumbUrl: string };

export type UserSelectT = {
  id: number | string;
  firstName: string;
  lastName: string;
  photoThumbUrl: string;
  hasAvatar?: boolean;
  initials?: string;
  roleAbilities?: string[];
  roleId?: number;
};

export abstract class UserSelectDataService {
  public abstract getUsers(): Observable<UserSelectT[]>;
}
